/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  products-alerts-action.ts
 *
 * Project Title :  Checkout
 *
 * Description	 :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Deepthi Bachu (E844276)
 *
 * @Date	     : Nov 18, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Suresh Jaladi - E807958
 * On            : Dec 06, 2019
 * Description   : ASDS-1811
 *
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes
 *
 ******************************************************************************/

import Action from './Action';
import ActionConstants from '../action-constants';
import CheckoutConstants from 'modules/checkout/constants/checkout-constants';

class ProductAlertActions extends Action {
    static hideAlert() {
        return (dispatch) => {
            dispatch({
                type: ActionConstants.SET_ALERT_MODEL,
                payload: {
                    showAlertMsg: false,
                    isAddToCartSuccess: false
                }
            });
        };
    }

    static closeInCompatibleProductsAlert() {
        return (dispatch) => {
            dispatch({
                type: ActionConstants.CLOSE_PRODUCT_ALERT_MODAL,
                payload: {}
            });
        };
    }

    static closeInValidProductsAlert() {
        return (dispatch) => {
            dispatch({
                type: ActionConstants.CLOSE_INVALID_PRODUCT_TO_ADD_TO_CART,
                payload: {}
            });
        };
    }

    static setGenricFields(system) {
        return (dispatch) => {
            dispatch({
                type: ActionConstants.SET_GENERIC_FIELDS,
                payload: {
                    inCompatibleProducts: false,
                    isBMSProductsAddedToCart: system.toLowerCase() === CheckoutConstants.BMS_SYS_NAME.toLowerCase(),
                    isApptusProductsAddedToCart: system.toLowerCase() === CheckoutConstants.APPTUS_SYS_NAME.toLowerCase(),
                }
            });
        };
    }

    static checkInCompatibleProducts(productsInCart: any, categoryName: string) {
        return productsInCart.filter(productInCart => {
            // checking any products in the cart that are not compatible with selected product.
            return productInCart.categoryName.toLowerCase() !== categoryName.toLowerCase();
        });
    }

    // static checkIfDLMUWIsInCart(productsInCart: any) {
    //     return productsInCart.filter(product => {
    //         // check if there is DLMU-W product in the cart
    //         return product.productId === CheckoutConstants.DLMUW_PRODUCT_ID;
    //     });
    // }

    // static checkIfFaultAnalyzerInCart(productsInCart: any) {
    //     return productsInCart.filter(product => {
    //         // check if there is DLMU-W product in the cart
    //         return product.productId === CheckoutConstants.FAULT_ANALYZER_SERVICES_PRODUCT_ID;
    //     });
    // }
}

export default ProductAlertActions;